<div class="card mb-4">
  <div class="card-body">
    <div>
      <div class="row justify-content-center">
        @if (currentAccount) {
          <div class="col-md-8">
            <h2>
              User Profile
              <div class="normal" data-qaa="userEmail">
                {{ currentAccount.email }}
              </div>
            </h2>
            @if (success) {
              <div class="alert alert-success" data-qaa="settingsSaved">
                <strong>Settings saved!</strong>
              </div>
            }
            @if (settingsForm.get("login").value) {
              <form
                (ngSubmit)="save()"
                [formGroup]="settingsForm"
                name="form"
                novalidate
                role="form"
              >
                <div class="mb-3">
                  <label class="form-control-label" for="firstName"
                    >First Name <span class="required">*</span></label
                  >
                  <input
                    class="form-control"
                    formControlName="firstName"
                    id="firstName"
                    name="firstName"
                    data-qaa="userFirstName"
                    placeholder="Your first name"
                    type="text"
                    required
                  />
                  @if (
                    settingsForm.get("firstName").invalid &&
                    (settingsForm.get("firstName").dirty ||
                      settingsForm.get("firstName").touched)
                  ) {
                    <div>
                      @if (settingsForm.get("firstName").errors.required) {
                        <small class="form-text text-danger">
                          Your first name is required.
                        </small>
                      }
                      @if (settingsForm.get("firstName").errors.minlength) {
                        <small class="form-text text-danger">
                          Your first name is required to be at least 1
                          character.
                        </small>
                      }
                      @if (settingsForm.get("firstName").errors.maxlength) {
                        <small class="form-text text-danger">
                          Your first name cannot be longer than 50 characters.
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <label class="form-control-label" for="lastName"
                    >Last Name <span class="required">*</span></label
                  >
                  <input
                    class="form-control"
                    formControlName="lastName"
                    id="lastName"
                    name="lastName"
                    data-qaa="userLastName"
                    placeholder="Your last name"
                    type="text"
                    required
                  />
                  @if (
                    settingsForm.get("lastName").invalid &&
                    (settingsForm.get("lastName").dirty ||
                      settingsForm.get("lastName").touched)
                  ) {
                    <div>
                      @if (settingsForm.get("lastName").errors.required) {
                        <small class="form-text text-danger">
                          Your last name is required.
                        </small>
                      }
                      @if (settingsForm.get("lastName").errors.minlength) {
                        <small class="form-text text-danger">
                          Your last name is required to be at least 1 character.
                        </small>
                      }
                      @if (settingsForm.get("lastName").errors.maxlength) {
                        <small class="form-text text-danger">
                          Your last name cannot be longer than 50 characters.
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <label class="form-control-label" for="lastName"
                    >Phone Number <span class="required">*</span></label
                  >
                  <input
                    (keydown)="onKeydown($event)"
                    [mask]="phoneMask"
                    [validation]="false"
                    [dropSpecialCharacters]="false"
                    required
                    class="form-control"
                    formControlName="phoneNumber"
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="Your phone number"
                    type="text"
                    data-qaa="userPhoneNumber"
                  />
                  @if (
                    settingsForm.get("phoneNumber").invalid &&
                    (settingsForm.get("phoneNumber").dirty ||
                      settingsForm.get("phoneNumber").touched)
                  ) {
                    <div>
                      @if (settingsForm.get("phoneNumber").errors.required) {
                        <small class="form-text text-danger">
                          Your phone number is required.
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <label class="form-control-label">MFA Status</label>
                  <div>
                    @if (currentAccount.mfaGaEnabled) {
                      <span class="text-muted" data-qaa="googleAuth"
                        >Google Authenticator</span
                      >
                    }
                    @if (currentAccount.mfaSmsEnabled) {
                      <span class="text-muted" data-qaa="smsAuth"
                        >SMS Code</span
                      >
                    }
                  </div>
                  @if (currentAccount.mfaEnabled) {
                    <button
                      (click)="resetMFA()"
                      class="btn btn-link ps-0 ms-0"
                      type="button"
                      data-qaa="resetMFA"
                    >
                      Reset MFA
                    </button>
                  }
                  @if (!currentAccount.mfaEnabled) {
                    <button
                      (click)="openSetupMFAModal()"
                      ngbPopover="Setup Multi-Factor Authentication for maximum security. This will require username, password, and a secret code in order to log into your account."
                      triggers="mouseenter:mouseleave"
                      popoverTitle="Setup MFA"
                      class="btn btn-link ps-0 ms-0"
                      type="button"
                      data-qaa="userSetupMFA"
                    >
                      Setup MFA
                    </button>
                  }
                </div>
                <div class="mb-3">
                  <label class="form-control-label">Avatar Color</label>
                  @if (!colorPickerEnabled) {
                    <div>
                      @if (settingsForm.get("avatarColor").value) {
                        <div
                          class="color-swatch"
                          [ngStyle]="{
                            'background-color':
                              '#' + settingsForm.get('avatarColor').value,
                          }"
                        ></div>
                      }
                      @if (!settingsForm.get("avatarColor").value) {
                        <span class="small em text-muted">Default</span>
                      }
                      <a
                        href="javascript:void(0)"
                        (click)="colorPickerEnabled = true"
                        data-qaa="editAvatar"
                        >Edit</a
                      >
                    </div>
                  }
                  @if (colorPickerEnabled) {
                    <div class="mb-3" data-qaa="colorPalette">
                      @for (c of colorService.colorChoices; track c) {
                        <div
                          style="display: inline-block; margin-right: 2px"
                          class="color-swatch clickable"
                          [ngStyle]="{
                            'background-color': '#' + c.hex,
                            color: colorService.getTextColor(c.hex),
                          }"
                          (click)="selectColor(c)"
                        ></div>
                      }
                    </div>
                  }
                </div>
                <br />
                <div>
                  <span class="bold">
                    Notification Delivery Method
                    <i
                      class="feather-help-circle"
                      ngbTooltip="How would you like to receive the notifications."
                    ></i>
                  </span>
                  <div class="mb-3 mt-1">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" for="notificationByEmail">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationByEmail"
                          id="notificationByEmail"
                          name="notificationByEmail"
                          data-qaa="notificationByEmail"
                        />
                        <span>Email</span>
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" for="notificationByApp">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationByApp"
                          id="notificationByApp"
                          name="notificationByApp"
                          data-qaa="notificationByApp"
                        />
                        <span>Firm360 App</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="bold">Notification Preferences</div>
                  <hr />
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationProjectChanges"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationProjectChanges"
                          id="notificationProjectChanges"
                          name="notificationProjectChanges"
                          data-qaa="notificationProjectChanges"
                        />
                        <span
                          >My Project Change Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification when you are assigned a project, or when a project assigned to you changes status."
                          ></i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationTaskChanges"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationTaskChanges"
                          id="notificationTaskChanges"
                          name="notificationTaskChanges"
                          data-qaa="notificationTaskChanges"
                        />
                        <span
                          >My Task Change Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification when you are assigned a task, or when a task assigned to you changes status."
                          ></i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationProjectComments"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationProjectComments"
                          id="notificationProjectComments"
                          name="notificationProjectComments"
                          data-qaa="notificationProjectComments"
                        />
                        <span
                          >My Project Comment Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification when you are mentioned in a comment on a project."
                          ></i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationProjectDocumentUploaded"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationProjectDocumentUploaded"
                          id="notificationProjectDocumentUploaded"
                          name="notificationProjectDocumentUploaded"
                          data-qaa="notificationProjectDocumentUploaded"
                        />
                        <span
                          >My Project Document Upload Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification a new document is uploaded to one of your projects."
                          ></i
                        ></span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationProjectClientMessage"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationProjectClientMessage"
                          id="notificationProjectClientMessage"
                          name="notificationProjectClientMessage"
                          data-qaa="notificationProjectClientMessage"
                        />
                        <span
                          >My Project Client Messages Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification when a client sends a message related to your projects."
                          ></i>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="form-check">
                      <label
                        class="form-check-label"
                        for="notificationProjectClientActionCompleted"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="notificationProjectClientActionCompleted"
                          id="notificationProjectClientActionCompleted"
                          name="notificationProjectClientActionCompleted"
                          data-qaa="notificationProjectClientActionCompleted"
                        />
                        <span
                          >My Project Client Actions Notifications
                          <i
                            class="feather-help-circle"
                            ngbTooltip="Get an email notification when a client completes an action item related to your projects."
                          ></i>
                        </span>
                      </label>
                    </div>
                  </div>
                  @if (hasClientAccessRequestsAuthority) {
                    <div class="mb-3">
                      <div class="form-check">
                        <label
                          class="form-check-label"
                          for="notificationClientAccessRequests"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControlName="notificationClientAccessRequests"
                            id="notificationClientAccessRequests"
                            name="notificationClientAccessRequests"
                            data-qaa="notificationClientAccessRequests"
                          />
                          <span
                            >Client Access Requests Notifications
                            <i
                              class="feather-help-circle"
                              ngbTooltip="Get an email notification for new client access requests."
                            ></i>
                          </span>
                        </label>
                      </div>
                    </div>
                  }
                  @if (hasClientAccessRequestsAuthority) {
                    <div class="mb-3">
                      <div class="form-check">
                        <label
                          class="form-check-label"
                          for="notificationClientMessageAssignedToUser"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControlName="notificationClientMessageAssignedToUser"
                            id="notificationClientMessageAssignedToUser"
                            name="notificationClientMessageAssignedToUser"
                            data-qaa="notificationClientMessageAssignedToUser"
                          />
                          <span
                            >Client Message Assigned To Me Notification
                            <i
                              class="feather-help-circle"
                              ngbTooltip="Get an email notification for client message assign to you."
                            ></i>
                          </span>
                        </label>
                      </div>
                    </div>
                  }
                  <div class="mb-3">
                    <label
                      >Client Actions Completed Notifications
                      <i
                        class="feather-help-circle"
                        [ngbTooltip]="clientActionTooltipText"
                      ></i></label
                    ><br />
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationClientActions"
                        class="form-check-input"
                        type="radio"
                        name="notificationClientActions"
                        id="inlineRadio10"
                        value="NONE"
                      />
                      <label class="form-check-label" for="inlineRadio10"
                        >None</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationClientActions"
                        class="form-check-input"
                        type="radio"
                        name="notificationClientActions"
                        id="inlineRadio11"
                        value="MY_CLIENTS"
                      />
                      <label class="form-check-label" for="inlineRadio11"
                        >My Clients
                        <i
                          class="feather-help-circle"
                          [ngbTooltip]="myClientsTooltipText"
                        ></i
                      ></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationClientActions"
                        class="form-check-input"
                        type="radio"
                        name="notificationClientActions"
                        id="inlineRadio12"
                        value="ALL_CLIENTS"
                      />
                      <label class="form-check-label" for="inlineRadio12"
                        >All Clients</label
                      >
                    </div>
                  </div>
                  @if (showClientMessages) {
                    <div class="mb-3">
                      <label
                        >New Client Message Notification
                        <i
                          class="feather-help-circle"
                          [ngbTooltip]="clientMessageTooltipText"
                        ></i></label
                      ><br />
                      <div class="form-check form-check-inline">
                        <input
                          formControlName="notificationClientMessage"
                          class="form-check-input"
                          type="radio"
                          name="notificationClientMessage"
                          id="inlineRadio7"
                          value="NONE"
                        />
                        <label class="form-check-label" for="inlineRadio7"
                          >None</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          formControlName="notificationClientMessage"
                          class="form-check-input"
                          type="radio"
                          name="notificationClientMessage"
                          id="inlineRadio8"
                          value="MY_CLIENTS"
                        />
                        <label class="form-check-label" for="inlineRadio8"
                          >My Clients
                          <i
                            class="feather-help-circle"
                            [ngbTooltip]="myClientsTooltipText"
                          ></i
                        ></label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          formControlName="notificationClientMessage"
                          class="form-check-input"
                          type="radio"
                          name="notificationClientMessage"
                          id="inlineRadio9"
                          value="ALL_CLIENTS"
                        />
                        <label class="form-check-label" for="inlineRadio9"
                          >All Clients</label
                        >
                      </div>
                    </div>
                  }
                  <div class="mb-3">
                    <label
                      >Client Upload Document Notifications
                      <i
                        class="feather-help-circle"
                        [ngbTooltip]="clientUploadDocumentTooltipText"
                      ></i></label
                    ><br />
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationDocument"
                        class="form-check-input"
                        type="radio"
                        name="notificationDocument"
                        id="inlineRadio1"
                        value="NONE"
                        data-qaa="notificationDocumentNone"
                      />
                      <label class="form-check-label" for="inlineRadio1"
                        >None</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationDocument"
                        class="form-check-input"
                        type="radio"
                        name="notificationDocument"
                        id="inlineRadio2"
                        value="MY_CLIENTS"
                        data-qaa="notificationDocumentMyClients"
                      />
                      <label class="form-check-label" for="inlineRadio2"
                        >My Clients
                        <i
                          class="feather-help-circle"
                          [ngbTooltip]="myClientsTooltipText"
                        ></i
                      ></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationDocument"
                        class="form-check-input"
                        type="radio"
                        name="notificationDocument"
                        id="inlineRadio3"
                        value="ALL_CLIENTS"
                        data-qaa="notificationDocumentAllClients"
                      />
                      <label class="form-check-label" for="inlineRadio3"
                        >All Clients</label
                      >
                    </div>
                  </div>
                  <div class="mb-3">
                    <label
                      >Open Project Notifications
                      <i
                        class="feather-help-circle"
                        ngbTooltip="Get a daily or weekly email summary of your open projects."
                      ></i></label
                    ><br />
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationOpenProjects"
                        class="form-check-input"
                        type="radio"
                        name="notificationOpenProjects"
                        id="inlineRadio4"
                        value="NONE"
                        data-qaa="notificationOpenProjectsNone"
                      />
                      <label class="form-check-label" for="inlineRadio4"
                        >None</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationOpenProjects"
                        class="form-check-input"
                        type="radio"
                        name="notificationOpenProjects"
                        id="inlineRadio5"
                        value="DAILY"
                        data-qaa="notificationOpenProjectsDaily"
                      />
                      <label class="form-check-label" for="inlineRadio5"
                        >Daily (M-F)</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationOpenProjects"
                        class="form-check-input"
                        type="radio"
                        name="notificationOpenProjects"
                        id="inlineRadio6"
                        value="WEEKLY"
                        data-qaa="notificationOpenProjectsWeekly"
                      />
                      <label class="form-check-label" for="inlineRadio6"
                        >Weekly (M)</label
                      >
                    </div>
                  </div>
                  <div class="mb-3">
                    <label
                      >Client Payment Received Notifications
                      <i
                        class="feather-help-circle"
                        ngbTooltip="Get an email notification when payment of selected clients was received."
                      ></i></label
                    ><br />
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationPaymentReceived"
                        class="form-check-input"
                        type="radio"
                        name="notificationPaymentReceived"
                        id="inlineRadio14"
                        value="NONE"
                        data-qaa="notificationOpenProjectsNone"
                      />
                      <label class="form-check-label" for="inlineRadio14"
                        >None</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationPaymentReceived"
                        class="form-check-input"
                        type="radio"
                        name="notificationPaymentReceived"
                        id="inlineRadio15"
                        value="MY_CLIENTS"
                        data-qaa="notificationOpenProjectsDaily"
                      />
                      <label class="form-check-label" for="inlineRadio15"
                        >My Clients</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        formControlName="notificationPaymentReceived"
                        class="form-check-input"
                        type="radio"
                        name="notificationPaymentReceived"
                        id="inlineRadio16"
                        value="ALL_CLIENTS"
                        data-qaa="notificationOpenProjectsWeekly"
                      />
                      <label class="form-check-label" for="inlineRadio16"
                        >All Clients</label
                      >
                    </div>
                  </div>
                </div>
                <button
                  [disabled]="settingsForm.invalid"
                  class="btn btn-primary"
                  type="submit"
                  data-qaa="saveUserProfileSettings"
                >
                  Save
                </button>
              </form>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
